import { useEffect, useState } from "react";
import { useParams, Outlet, useNavigate } from "react-router-dom";
import { fetchProject } from "../utils/api";
import Loading from '../features/uiStatus/components/Loading';
import { useLoading } from '../features/uiStatus/hooks/useLoading';

function DashboardPage() {
    const navigate = useNavigate();
    const { projectId } = useParams();

    const [project, setProject] = useState(null);
    const { isLoading, setLoading } = useLoading();

    useEffect(() => {
        fetchProject(projectId)
            .then(setProject)
            .catch(() => navigate("/dashboard/select", { replace: true }))
            .finally(() => setLoading(false));
    }, [projectId, navigate, setLoading]);

    return (
        <Loading isLoading={isLoading}>
            <div className="box-border flex w-full flex-1 flex-col items-stretch justify-start bg-bg-primary text-text-primary min-h-0 has-[.page-shell-fill]:min-h-0 has-[.page-shell-fill]:flex-1 has-[.page-shell-fill]:overflow-hidden has-[.page-shell-auto]:h-auto has-[.page-shell-auto]:min-h-full has-[.page-shell-auto]:flex-none has-[.page-shell-auto]:overflow-visible">
                <Outlet context={{ project }} />
            </div>
        </Loading>
    );
}

export default DashboardPage;
